type Context = 'search';

export type Key =
  | 'quick-search'
  | 'filtered-records'
  | 'saved'
  | 'segments'
  | 'segments-recommended'
  | 'filters'
  | 'filter-options'
  | 'filter-option-autocomplete'
  | 'register'
  | 'multi-level-one'
  | 'multi-level-two'
  | 'multi-level-search';

export type Value = `${Context}-${Key}`;

export const Keys: Record<Key, Value> = {
  filters: 'search-filters',
  'filter-options': 'search-filter-options',
  'filter-option-autocomplete': 'search-filter-option-autocomplete',
  'quick-search': 'search-quick-search',
  'filtered-records': 'search-filtered-records',
  saved: 'search-saved',
  segments: 'search-segments',
  'segments-recommended': 'search-segments-recommended',
  register: 'search-register',
  'multi-level-one': 'search-multi-level-one',
  'multi-level-two': 'search-multi-level-two',
  'multi-level-search': 'search-multi-level-search',
};
